/*jslint node: true*/
"use strict";

var ko = require("pli/knockout");
var pli = require("pli/forms");
var pliObservable = require("pli/forms-knockoutcontrols");

var dataCache = require("../datacache");
var entityRegistry = require("../entity-registry");
var picklistItemExtensions = require("../picklist-common/picklistItemViewModelExtensions");


//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// WellStatusViewModel
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

//-------------------------------------------
function WellStatusViewModel(form) {
    this.initPicklistItem("Geo-WellStatus-", form);

    this.code = this.id = pliObservable(null, null, "required");
    this.description = pliObservable(null);
    this.producingStatus = pliObservable(null, dataCache.getObservable("producingCode"), "picklist", "required");

    this.extras.displayName = ko.computed(WellStatusViewModel.prototype._computeDisplayName, this);
}


//-------------------------------------------
WellStatusViewModel.prototype.fromCacheItem = function wellStatusFromCacheItem(item) {
    var record;
    if (item && item.length) {
        record = {
            guid: item[item.length - 1],
            code: item[0],
            description: item[1],
            producingStatus: item[2]
        };
    } else {
        record = item;
    }
    return record;
};


//-------------------------------------------
WellStatusViewModel.prototype.load = function loadWellStatus(record) {
    record = record || {};

    this.code.reset();
    this.producingStatus.reset();

    this.guid(record.guid || null);
    this.code(record.code || null);
    this.description(record.description || null);
    this.producingStatus(record.producingStatus || null);
};


//-------------------------------------------
WellStatusViewModel.prototype._computeDisplayName = function computeWellStatusDisplayName() {
    var id = this.id();
    return (id ? "Well Status ".concat(id) : "(No code yet)");
};


//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// Initialization
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

//-------------------------------------------
var wellStatusForm = pli.forms.registry.wellStatusForm;
if (typeof wellStatusForm !== "object") { throw new Error("Well Status form element could not be found - did you render it using CreateWellStatusForm?"); }
if (wellStatusForm.viewModel) { throw new Error("Well Status form has already been initialized"); }

ko.utils.extend(WellStatusViewModel.prototype, picklistItemExtensions.mixins);
wellStatusForm.viewModel = new WellStatusViewModel(wellStatusForm);

entityRegistry.wellStatus.open.create = entityRegistry.wellStatus.open.edit = wellStatusForm.viewModel.open;
entityRegistry.wellStatus.getPicklistBehaviourData = function getPicklistBehaviourData() {
    return {
        onNewItem: wellStatusForm.viewModel.open,
        onOpenItem: wellStatusForm.viewModel.open,
        picklistData: dataCache.getObservable("wellStatus")
    };
};


//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// Exports
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

//-------------------------------------------
module.exports = WellStatusViewModel;



//////////////////
// WEBPACK FOOTER
// ./app/picklist-wellstatus/wellStatusViewModel.js
// module id = 716
// module chunks = 49